'use client';

import { createContext, useContext } from 'react';
import type { ButtonSize, ButtonVariant, ButtonColor } from '../Button/types';

export interface IButtonGroupContext {
  size?: ButtonSize,
  variant?: ButtonVariant,
  color?: ButtonColor,
}

export const ButtonGroupContext = createContext<IButtonGroupContext | null>(null);

export const useButtonGroupContext = (): IButtonGroupContext | null => useContext(ButtonGroupContext);
